import styled from "styled-components";

const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
  height: 100%;
`;

const ContainerLeftEditRate = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
  width: 100%;
  .divHeaderRight {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .divTitle {
      display: flex;
      flex-direction: row;
      gap: 5px;
      align-items: center;
      .divIcon {
        cursor: pointer;
      }
      span {
        font-size: 14px;
        font-weight: 700;
      }
    }
    .divRate {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      border-radius: 10px;
      box-shadow: 0px 5px 5px 0px #0000001f;

      .divRateTitle {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        gap: 5px;
        background-color: black;
        color: white;
        font-size: 14px;
        font-weight: 700;
        padding: 3px 15px;
        border-radius: 10px 0px 0px 10px;
      }
      .divRateValue {
        display: flex;
        align-items: center;
        height: 100%;
        background-color: white;
        font-size: 14px;
        font-weight: 700;
        padding: 3px 15px;
        border-radius: 0px 10px 10px 0px;
      }
    }
  }
  .divInputs {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 5px;
    height: 17%;
    .divInputText {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      gap: 10px;
      background-color: white;
      padding: 10px;
      border-radius: 10px;
      box-shadow: 0px 5px 5px 0px #0000001f;
      .divInputTitle {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        gap: 5px;
      }
      span {
        font-size: 12px;
        font-weight: 700;
      }
      hr {
        border: 0.5px solid #e0e0e0;
        background-color: #e0e0e0;
        padding: 0px;
        margin: 0px;
      }
      input {
        border-radius: 5px;
        background-color: #f5f5f5;
        border: none;
        padding: 10px;
        font-size: 14px;
        font-weight: 600;
      }
    }
    .divInputLocation {
      display: flex;
      flex-direction: column;
      gap: 8px;
      background-color: white;
      justify-content: space-around;

      padding: 10px;
      border-radius: 10px;
      box-shadow: 0px 5px 5px 0px #0000001f;
      width: 40%;
      .divLocationTitle {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        gap: 5px;
      }
      span {
        font-size: 12px;
        font-weight: 700;
      }
      hr {
        border: 0.5px solid #e0e0e0;
        background-color: #e0e0e0;
        padding: 0px;
        margin: 0px;
      }
      .inputLocation {
        border-radius: 5px;
        background-color: #f5f5f5;
        border: none !important;
        padding: 10px;
        font-size: 14px;
        font-weight: 600;
      }
    }
  }
  .divMap {
    display: flex;
    flex-direction: column;
    box-shadow: 0px 5px 5px 0px #0000001f;
    .divHeaderMap {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      background-color: white;
      padding: 10px;
      border-radius: 10px 10px 0px 0px;
      align-items: center;
      gap: 5px;
      span {
        font-size: 14px;
        font-weight: 700;
      }
      .divIcons {
        display: flex;
        flex-direction: row;
        gap: 5px;
      }
    }
  }
`;

const ContainerRightEditRate = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 33%;
  .divDynamicRate {
    display: flex;
    flex-direction: column;
    gap: 12px;
    background-color: white;
    border-radius: 10px;
    padding: 15px 10px;
    box-shadow: 0px 5px 5px 0px #0000001f;
    hr {
      border: 0.5px solid #e0e0e0;
      background-color: #e0e0e0;
      padding: 0px;
      margin: 0px;
    }
    .divSwitchDynamic {
      display: flex;
      flex-direction: row;
      justify-content: start;
      align-items: center;
      gap: 5px;
      span {
        font-size: 12px;
        font-weight: 700;
      }
    }
    .divPricePerKilometerTitle {
      display: flex;
      flex-direction: row;
      gap: 5px;
      span {
        font-size: 12px;
        font-weight: 700;
      }
    }
    .divPricePerKilometerInputs {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      gap: 5px;

      span {
        font-size: 12px;
        font-weight: 700;
      }
      input {
        border-radius: 5px;
        background-color: #f5f5f5;
        border: none;
        padding: 5px;
        width: 50px;
        height: 30px;
        text-align: center;
        font-weight: 700;
      }
    }
    .divScheduleTitle {
      display: flex;
      flex-direction: row;
      gap: 5px;
      span {
        font-size: 12px;
        font-weight: 700;
      }
    }
    .divScheduleInputs {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      gap: 5px;
      span {
        font-size: 12px;
        font-weight: 700;
      }
      input {
        border-radius: 5px;
        background-color: #f5f5f5;
        border: none;
        padding: 5px;
        width: 50px;
        height: 30px;
        text-align: center;
        font-weight: 700;
      }
      select {
        width: 60px;
        height: 30px;
        border-radius: 8px;
        border: none;
        background-color: #f1f1f1;
        font-family: "Roboto", Helvetica, sans-serif;
        font-weight: 400;
        font-size: 13px;
        line-height: 1.2;
        color: #13131d;
        text-align: center;
        font-weight: 700;
      }
      input,
      select:focus {
        outline: none;
      }
    }
    .divPriceOnDemandTitle {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 5px;
      span {
        font-size: 12px;
        font-weight: 700;
      }
      input {
        border-radius: 5px;
        background-color: #f5f5f5;
        border: none;
        padding: 5px;
        width: 100px;
        height: 30px;
        text-align: center;
        font-weight: 700;
      }
    }
    .divSwitchOnDemand {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 5px;
      span {
        font-size: 12px;
        font-weight: 700;
      }
    }
  }
  .divColor {
    display: flex;
    flex-direction: column;
    gap: 12px;
    background-color: white;
    border-radius: 10px;
    padding: 15px 10px;

    box-shadow: 0px 5px 5px 0px #0000001f;
    .color-picker-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      gap: 10px;
      position: relative;
    }

    .color-picker-wrapper {
      background-color: lightgray;
      width: 35px;
      height: 35px;
      border-radius: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .color-picker-circle {
      width: 25px;
      height: 25px;
      border-radius: 50%;
      margin: 0 auto;
      cursor: pointer;
    }

    .color-picker-label {
      font-weight: bold;
    }

    .color-picker-modal {
      position: absolute;
      background-color: black;
      display: flex;
      flex-direction: row;
      z-index: 1;
      gap: 5px;
      padding: 5px;
      border-radius: 5px;
      top: 45px;
      left: 0;
    }

    .color-picker-option {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      margin: 0 auto;
      cursor: pointer;
    }
    hr {
      border: 0.5px solid #e0e0e0;
      background-color: #e0e0e0;
      padding: 0px;
      margin: 0px;
    }
    .divColorTitle {
      display: flex;
      flex-direction: row;
      gap: 5px;
      span {
        font-size: 12px;
        font-weight: 700;
      }
    }
    .divColorInputs {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      gap: 5px;
      input {
        border-radius: 5px;
        background-color: #f5f5f5;
        border: none;
        padding: 5px;
        width: 50px;
      }
      span {
        font-size: 14px;
        font-weight: 700;
      }
    }
  }
  .divPriority {
    display: flex;
    flex-direction: column;
    gap: 12px;
    background-color: white;
    border-radius: 10px;
    padding: 15px 10px;

    box-shadow: 0px 5px 5px 0px #0000001f;
    hr {
      border: 0.5px solid #e0e0e0;
      background-color: #e0e0e0;
      padding: 0px;
      margin: 0px;
    }
    .divPriorityTitle {
      display: flex;
      flex-direction: row;
      gap: 5px;
      span {
        font-size: 12px;
        font-weight: 700;
      }
    }
    .divPrioritySelect {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: start;
      gap: 5px;
      span {
        font-size: 14px;
        font-weight: 700;
      }
      .divPriorityInputs {
        display: flex;
        flex-direction: row;
        align-items: center;
        background-color: #f5f5f5;
        width: 40%;
        padding: 5px;
        border-radius: 10px;
        select {
          background-color: #f5f5f5;
          border-radius: 5px;
          border: none;
          padding: 5px;
        }
      }
    }
  }
`;

export default { MainContainer, ContainerLeftEditRate, ContainerRightEditRate };
